<template>
  <div>
    <NavigationBar titel="Stundenmeldungen" :actions="actions"></NavigationBar>
    <section>
      <template>
        <v-container fluid>
          <v-row class="match-height">
            <v-col cols="12" sm="6" v-if="canUsePayrollBatches">
              <time-sheet-status-card
                :timeSheets="timeSheets"
              ></time-sheet-status-card>
            </v-col>
            <v-col cols="12" sm="6" v-if="canReviewTimeSheets">
              <quota-checker
                :userId="showAllTimeSheets ? null : currentUserId"
              ></quota-checker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <time-sheets-data-table
                :timeSheets="timeSheets"
              ></time-sheets-data-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import TimeSheetsDataTable from "@/components/accounting/time-sheets/TimeSheetsDataTable.vue";
import QuotaChecker from "@/components/accounting/QuotaChecker.vue";
import TimeSheetStatusCard from "@/components/accounting/TimeSheetStatusCard.vue";
import { ACCOUNTING } from "@/store/modules.js";
import { GET_TIME_SHEETS, GET_PAYROLL_TYPES } from "@/store/action-types.js";
import {
  ACCOUNTING_TIME_SHEETS_create,
  ACCOUNTING_TIME_SHEETS_read_all,
  ACCOUNTING_TIME_SHEETS_review,
  ACCOUNTING_PAYROLL_BATCHES_read,
} from "@/data/permission-types.js";
import { auth } from "@/firebase";

export default {
  name: "accounting-time-sheets",
  components: {
    NavigationBar,
    TimeSheetsDataTable,
    SupportTools,
    QuotaChecker,
    TimeSheetStatusCard,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          permission: `${ACCOUNTING_TIME_SHEETS_create}`,
          icon: "mdi-plus-circle",
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({ name: "accounting-time-sheets-new" });
          },
        },
        {
          title: "Listen-Ansicht",
          icon: "mdi-dock-left",
          actionStyle: "textBtn",
          permission: `${ACCOUNTING_TIME_SHEETS_read_all}`,
          function: () => {
            this.$router.push({
              name: "accounting-time-sheets-split",
              params: { organizationId: this.$route.params.organizationId },
            });
          },
        },
        { divider: true },
        { actionStyle: "clipboardBtn" },
      ],
    };
  },
  computed: {
    timeSheets() {
      return this.$store.state.accounting.timeSheets;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "timeSheets", data: this.timeSheets }];
    },
    showAllTimeSheets() {
      return this.$store.getters["organization/checkPermissionByID"](
        `${ACCOUNTING_TIME_SHEETS_read_all}`,
      );
    },
    canReviewTimeSheets() {
      return this.$store.getters["organization/checkPermissionByID"](
        `${ACCOUNTING_TIME_SHEETS_review}`,
      );
    },
    canUsePayrollBatches() {
      return this.$store.getters["organization/checkPermissionByID"](
        `${ACCOUNTING_PAYROLL_BATCHES_read}`,
      );
    },
    currentUserId() {
      return auth.currentUser?.uid || null;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      // Fetch payroll types for quota checker
      this.$store.dispatch(`${ACCOUNTING}${GET_PAYROLL_TYPES}`, {
        organizationId: this.$route.params.organizationId,
      });

      var allowedToReadAllTimeSheets = this.$store.getters[
        "organization/checkPermissionByID"
      ](`${ACCOUNTING_TIME_SHEETS_read_all}`);
      if (allowedToReadAllTimeSheets) {
        this.$store.dispatch(`${ACCOUNTING}${GET_TIME_SHEETS}`, {
          organizationId: this.$route.params.organizationId,
          query: {
            queryIsFiltered: false,
          },
        });
      } else {
        this.$store.dispatch(`${ACCOUNTING}${GET_TIME_SHEETS}`, {
          organizationId: this.$route.params.organizationId,
          query: {
            queryIsFiltered: true,
            onlyOwn: true,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.theme--dark .border-right {
  border-right-color: rgba(255, 255, 255, 0.08);
}
</style>
